import React, {useContext, useEffect, useState} from "react";
// import { useCookies } from "react-cookie";
import {Link, useParams, useSearchParams} from "react-router-dom";
// import Phylotree from "../../components/Phylotree";
import fetchOptionsBuilder from "../../fetchOptionBuilder";
import '../../styles/pages/geneFamilies_details.scss'
import WorkflowContext from "../../workflowContext";

function getSessionStorageOrDefault(key, defaultValue) {
    const stored =  sessionStorage.getItem(key);
    if (!stored) {
        return defaultValue;
    }
    return JSON.parse(stored);

    }    

export default function VFGeneDetail() {
    // const [cookies, setCookie, removeCookie] = useCookies(['auth', 'userid']);
    const [open, setOpen] = useState(false) // eslint-disable-line no-unused-vars
    const [clusterData, setClusterData] = useState([]);
    const [clusterTerm, setClusterTerm] = useState('');
    const [sortBy, setSortBy] = useState(0);
    const [sortDir, setSortDir] = useState([0,0]);
    const workflow = useContext(WorkflowContext);

    let {id} = useParams()
    const [searchParams, setSearchParams] = useSearchParams(); // eslint-disable-line no-unused-vars
    const gene_product = searchParams.get('gene_product');
    const drug_class = searchParams.get('drug_class');

    const [apitoken, setApitoken] = useState(             // eslint-disable-line no-unused-vars
        getSessionStorageOrDefault('apitoken', null)
    );

    const getDataUserId = JSON.parse(sessionStorage.getItem('userid'));       

    // console.log(id, gene_product, drug_class);

    useEffect(() => {
        //get cluster data for selected gene
        if (id) {
            fetch(process.env.REACT_APP_VISUALIZATION_API_PATH + `vfgenenames/${encodeURIComponent(encodeURIComponent(id))}/genes/json?drug_class=${encodeURIComponent(drug_class)}&gene_product=${encodeURIComponent(gene_product)}`, fetchOptionsBuilder(apitoken, workflow, getDataUserId))
            .then(response => response.json())
            .then(data => setClusterData(data));
        }
    }, [workflow, id, apitoken, getDataUserId, drug_class, gene_product]);

    useEffect(() => {
        document.title = `${id ? id : 'Virulence Factors'} | Palmona Pathogenomics`
    }, [id]);

    const renderTableRow = (data) => {
        return (
            <tr>
                <td><Link id="link" to={`/strains/detail/${data.genome_id}`}>{data.genome_id}</Link></td>
                <td>{data.gene_product}</td>
            </tr>
        );
    }

    const filteredClusterData = clusterData.filter(cluster => (
        cluster.genome_id.toLowerCase().includes(clusterTerm.toLowerCase()) ||
        cluster.gene_product.toLowerCase().includes(clusterTerm.toLowerCase())
    ))
    const tableHeaders = ['genome_id', 'gene_product'];
    filteredClusterData.sort((a, b) => {
        if (!a[tableHeaders[sortBy]] && !b[tableHeaders[sortBy]]) return 0;
        if (!a[tableHeaders[sortBy]]) return 1;
        if (!b[tableHeaders[sortBy]]) return -1;
        const x = String(a[tableHeaders[sortBy]]).localeCompare(String(b[tableHeaders[sortBy]]));
        return sortDir[sortBy] ? -x : x;
    })

    const changeSort = col => {
        setSortBy(col);
        const newSortDir = [...sortDir];
        newSortDir[col] = 1 - sortDir[col];
        setSortDir(newSortDir);
    }

    return (
        <div className="screen geneFamilies details">
            <div className="container mt-4 text-secondary">
                <div className="row">
                    <h1 className={!open ? '' : 'active'}>Virulence Factors Detail View</h1>
                    {!id && <hr style={{ margin: '5px 14px 14px', color: '#888', overflow: 'hidden'}}/>}
                        {id ? <>
                            <div className={!open ? 'col left' : 'col left active'}>
                                <hr/>
                                <h2>Strains Found with {id}</h2>
                                <div className="subrow">
                                    <div className="box1">
                                        <p>Entries per page:</p>
                                        <div className="select-wrap">
                                            <select name="countPerPage" id="countPerPage">
                                                <option value="10">10</option>
                                                {filteredClusterData?.length > 10 && <option value="20">20</option>}
                                                {filteredClusterData?.length > 20 && <option value="30">30</option>}
                                                {filteredClusterData?.length > 30 && <option value="40">40</option>}
                                                {filteredClusterData?.length > 40 && <option value="50">50</option>}
                                            </select>
                                            <span>Viewing all entries</span>
                                        </div>
                                    </div>
                                <input type="search" name="searchRows" id="searchRows" placeholder="Search" onChange={(e) => setClusterTerm(e.target.value)} />
                                </div>
                                <table className="table">
                                    <thead className="thead-dark">
                                    <tr>
                                        <th scope="col" className={sortBy === 0 ? 'sort' : 'nosort'} onClick={() => changeSort(0)}>Genome ID {sortDir[0] ? '▲' : '▼'}</th>
                                        <th scope="col" className={sortBy === 1 ? 'sort' : 'nosort'} onClick={() => changeSort(1)}>Function {sortDir[1] ? '▲' : '▼'}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {filteredClusterData?.map((data) => renderTableRow(data, true))}
                                    </tbody>
                                </table>
                            </div>
                            {/* <div className="col right">
                                <div className="top">
                                    <h2>Phylotree</h2>
                                    {!open ?
                                        <button onClick={() => setOpen(true)}>
                                            <i class="bi bi-arrows-angle-expand"></i>
                                            Expand
                                        </button>
                                    :
                                        <button onClick={() => setOpen(false)}>
                                            <i class="bi bi-x-lg"></i>
                                            Close
                                        </button>
                                    }
                                </div>
                                <div className={!open ? 'content' : 'content active'}>
                                    <Phylotree id={id} />
                                </div>
                            </div> */}
                        </> : 
                            <div className="no-data">
                                <h3>Select an AMR Gene to see its details</h3>
                                <Link className="link" to='/gene-names'>
                                    Go to AMR Genes
                                </Link>
                            </div>
                        }
                </div>
            </div>
        </div>
    );
}
